export default "__VITE_ASSET__lC0zCn3v__"